import { Padding } from '@mui/icons-material';

export const keywordResearchDashBoardCss = {
  card: {
    marginTop: '1rem',
    width: 'Hug (1,140px)',
    height: 'Hug (529.87px)',
    gap: '16px',
    backgroundColor: 'var(--color-white)',
    boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)',
    padding: '24px',
    borderRadius: '8px',
    marginBottom: '1rem'
  },
  cardContent: {
    padding: 0
  },
  keywordResearch: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-30)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'left',
    marginBottom: '1rem',
    color: 'var(--color-primary)'
  },
  keywordResearchDescription: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-text-purple)',
    mb: 2
  },
  listFrontIcon: {
    width: '18px',
    // height: '18px',
    color: 'var(--color-secondary)'
  },
  listItem: {
    // width: 'Fill (1,016px)',
    height: '72px',
    padding: '16px 16px 16px 16px',
    borderRadius: '8px',
    border: '1px solid',
    opacity: '0px',
    borderColor: 'var(--color-border)',
    mb: 1.8,
    '&:hover': {
      backgroundColor: 'rgba(235, 235, 245, 1)', // Adjust color as per your design requirement
      cursor: 'pointer' // Change cursor to pointer to indicate it's clickable
    },
    display: 'flex',
    alignItems: 'center'
  },
  listItemText: {
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    paddingLeft: '1rem',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-18)',
    color: 'rgba(29, 41, 57, 1)'
  },
  listTypo: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  listItemIcon: {
    // width: '24px',
    // height: '24px',
    minWidth: '0px',
    color: 'var(--color-primary)'
  },
  arrowForwardIcon: {
    width: '24px',
    height: '24px'
  },
  navigateNextIcon: {
    color: 'var(--color-primary)'
  },
  bookIcon: { color: 'var(--color-purple-deep-alt)' },
  breadCrumbText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    '&:hover': {
      cursor: 'pointer' // Change cursor to pointer on hover
    }
  },
  breadCrumbLightText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)',
    '&:hover': {
      cursor: 'pointer' // Change cursor to pointer on hover
    }
  },
  hideArrowForTextFields: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  removeBorderEffectForTextField: {
    '& fieldset': { borderColor: 'var(--color-text-tertiary)' }, // Initial border color
    '&:hover fieldset': {
      borderColor: 'var(--color-purple-deep-alt)'
    }, // Border color on hover
    '&.Mui-focused fieldset': {
      borderColor: 'var(--color-purple-deep-alt)'
    }, // Border color on focus
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: 'var(--color-purple-deep-alt)' // Hover effect for the border
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--color-purple-deep-alt)' // Focus effect for the border
      }
    }
  },
  customTollTipText: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    textAlign: 'left',
    color: '#120242'
  },
  customTollTipTextDark: {
    fontWeight: 700
  },
  linkStyle: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  chipSx: {
    padding: '0px 6px 2px 6px',
    gap: '6px',
    background: 'var(--color-success-bg)',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  countryChipSx: {
    maxHeight: '32px',
    gap: '0px',
    borderRadius: '4px',
    padding: '4px',
    background: 'var(--color-bg-muted-alt)',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-heading)'
  },
  createListBtnBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
};

export const exportCsvModalSxs = {
  mainBox: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '14px',
    paddingBottom: '2rem'
  },
  text: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  },
  loaderSx: {
    color: 'var(--color-secondary)'
  },
  icon: {
    width: '26px',
    height: '26px',
    color: 'var(--color-secondary)'
  },
  downloadBtn: {
    width: '100%'
  }
};

export const searchProgressSx = {
  linearProgress: {
    borderRadius: 5,
    height: '6px'
  },
  text: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    textAlign: 'center',
    fontWeight: '600',
    color: 'var(--color-primary)'
  },
  boldTag: {
    color: 'var(--color-primary)'
  },
  link: {
    textDecoration: 'underline', // Add underline
    textDecorationColor: 'rgba(0, 160, 129, 1)', // Color of the underline
    '&:hover': {
      textDecorationColor: 'rgba(0, 160, 129, 1)'
    }
  },
  linkText: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'rgba(0, 160, 129, 1)'
  },
  helpIcon: {
    width: '16px',
    height: '16px',
    color: 'rgba(168, 166, 191, 1)',
    '&:hover': {
      color: 'var(--color-primary)'
    },
    marginLeft: '4px'
  },
  headingBox: {
    display: 'flex',
    alignItems: 'center'
  },
  alertSx: {
    '.MuiAlert-action': {
      paddingLeft: '4px'
    }
  }
};

export const UpgradeSearchCreditModalSxs = {
  mainBox: {
    paddingLeft: '12px',
    paddingRight: '12px',
    maxWidth: '26rem'
  },
  headerText: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)'
  },
  description: {
    textAlign: 'center',
    //styleName: Text md/Regular;
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  btnBox: {
    marginTop: '1rem',
    marginBottom: '2rem',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px'
  },
  btnSx: {
    width: '100%',
    padding: '10px 18px 10px 18px',
    gap: '8px',
    borderRadius: '6px'
  },
  buyCredit: {
    borderColor: 'rgba(98, 14, 209, 1)',
    '&:hover ': {
      borderColor: 'rgba(98, 14, 209, 1)' // Removes the hover effect by setting border color
    }
  },
  buyCreditText: {
    color: 'rgba(98, 14, 209, 1)',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left'
  },
  upgradePlanText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  upgradePlan: {
    backgroundColor: 'var(--color-secondary)',
    '&:hover ': {
      backgroundColor: 'var(--color-secondary)' // Removes the hover effect by setting border color
    }
  }
};

export const viewAllKeywordModalSxs = {
  mainBox: {
    paddingBottom: '31px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '30rem'
  },
  headerText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  },
  desc: {
    // maxWidth: '70%',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    mt: 2
  },
  descSpan: {
    color: 'var(--color-primary)',
    fontWeight: 600
  },
  donNotBox: {
    display: 'flex',
    alignItems: 'center',
    mt: 1,
    backgroundColor: 'rgba(246, 247, 251, 1)',
    padding: '12px 16px 12px 16px',
    gap: '8px',
    borderRadius: '12px'
  },
  btnBox: {
    mt: 1,
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px'
  },
  doNotShowText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  checkBox: {
    width: '8px',
    height: '8px'
  },
  btn: {
    width: '100%',
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '6px'
  }
};

export const UpgradePlanLiteModalSxs = {
  mainBox: {
    border: '1px solid var(--color-secondary)',
    backgroundColor: 'var(--color-success-bg-ultra)',
    padding: '16px',
    gap: '24px',
    alignItems: 'center',
    borderRadius: '8px',
    // display: 'flex',
    justifyContent: 'space-between'
  },
  headerBox: {
    display: 'flex',
    gap: '10px',
    alignItems: 'start',
    padding: '0.5rem'
  },
  headerText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-input)',
    mt: 1
  },
  btn: {
    width: 'max-content',
    padding: '8px 12px 8px 12px',
    gap: '8px',
    borderRadius: '6px',
    backgroundColor: 'var(--color-secondary)',
    '&:hover': {
      backgroundColor: 'rgba(37, 211, 177, 0.8)'
    }
  },
  btnCredits: {
    width: 'max-content',
    padding: '8px 12px 8px 12px',
    gap: '8px',
    borderRadius: '6px'
  },
  btnText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left'
  },
  closeIcon: {
    color: 'rgba(65, 66, 71, 1)',
    marginLeft: '10px',
    marginBottom: 'auto',
    marginTop: '-10%'
  },
  img: {
    marginTop: '2.5px'
    //marginLeft: '1rem'
  },
  btnBox: {
    display: 'flex',
    gap: '8px'
  }
};

export const generateBlogCss = {
  mainBox: {
    maxWidth: '410px',
    padding: '0px 16px 32px 16px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-22)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '24px'
  },
  spanDescSx: {
    fontWeight: 600,
    color: 'var(--color-primary)'
  },
  btnSx: {
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '6px'
  }
};

//export const buySearchCreditModalSxs = {
//  headerBoxSx: {
//    display: 'flex',
//    justifyContent: 'space-between',
//    alignItems: 'center'
//  },
//  headerTitleSx: {
//    fontFamily: 'Inter',
//    fontSize: 'var(--font-size-20)',
//    fontWeight: 600,
//    lineHeight: 'var(--line-height-30)',
//    textAlign: 'left',
//    color: 'var(--color-primary)'
//  },
//  headerIconBtnSx: {
//    height: '40px',
//    padding: '8px',
//    paddingRight: '5px'
//  },
//  descSx: {
//    fontFamily: 'Inter',
//    fontSize: 'var(--font-size-14)',
//    fontWeight: 400,
//    lineHeight: 'var(--line-height-20)',
//    textAlign: 'left',
//    color: 'var(--color-text-secondary)',
//    marginBottom: '10px'
//  },
//  cardBoxSx: {
//    flexGrow: 1,
//    padding: 2
//  },
//  cardSx: {
//    padding: '24px',
//    gap: '16px',
//    borderRadius: '8px',
//    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
//    minWidth: '233px'
//  },
//  priceTextSx: {
//    fontFamily: 'Inter',
//    fontSize: 'var(--font-size-16)',
//    fontWeight: 500,
//    lineHeight: 'var(--line-height-24)',
//    textAlign: 'left',
//    color: 'var(--color-text-tertiary)',
//    marginBottom: '16px'
//  },
//  creditTextSx: {
//    fontFamily: 'Inter',
//    fontSize: 'var(--font-size-16)',
//    fontWeight: 500,
//    lineHeight: 'var(--line-height-24)',
//    textAlign: 'left',
//    color: 'var(--color-primary)',
//    marginBottom: '16px',
//    width: 'max-content'
//  },
//  subGridSx: {
//    paddingLeft: { xs: '16px', md: '0px !important' }
//  },
//  cardContentSx: {
//    padding: '0px !important'
//  },
//  spanStyle: {
//    fontSize: 'var(--font-size-32)',
//    fontWeight: 700
//  },
//  btnSx: {
//    padding: '10px 18px 10px 18px',
//    gap: '8px',
//    borderRadius: '6px'
//  },
//  footerTextSx: {
//    fontFamily: 'Inter',
//    fontSize: 'var(--font-size-14)',
//    fontWeight: 400,
//    lineHeight: 'var(--line-height-20)',
//    textAlign: 'left',
//    color: 'var(--color-text-secondary)',
//    maxWidth: '29rem'
//  },
//  footerBoxSx: {
//    display: 'flex',
//    justifyContent: 'space-between',
//    alignItems: 'center'
//  },
//  closeIcon: {
//    color: 'var(--color-text-sidebar-icon)'
//  },
//  bestValueChip: {
//    position: 'absolute',
//    top: '-1rem', // Move the chip upwards to make it half outside the card
//    left: '50%',
//    transform: 'translateX(-50%)', // Center horizontally
//    background: 'var(--color-success-bg)',
//    color: 'var(--color-primary)',
//    padding: '0.25rem 0.5rem', // Add padding to make it visually balanced
//    borderRadius: '12px', // Slightly round the chip for aesthetics
//    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Optional: Add shadow for better visibility
//    zIndex: 20
//  }
//};

export const buySearchCreditModalSxs = (theme) => ({
  headerBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  headerTitleSx: {
    ...theme.typography.custom({ fontWeight: 600, lineHeight: 'var(--line-height-30)' }),
    fontSize: theme.spacing(2.5), // Converts 20px to theme spacing
    color: theme.palette.primary.main
  },
  headerIconBtnSx: {
    height: theme.spacing(5), // 40px
    padding: theme.spacing(1),
    paddingRight: theme.spacing(0.625) // 5px
  },
  descSx: {
    ...theme.typography.custom({ lineHeight: theme.spacing(2.5) }), // 20px
    fontSize: theme.spacing(1.75), // 14px
    color: 'var(--color-text-secondary)',
    marginBottom: theme.spacing(1.25) // 10px
  },
  cardBoxSx: {
    flexGrow: 1,
    padding: theme.spacing(2) // Dynamic but standardized
  },
  cardSx: {
    padding: theme.spacing(3), // 24px
    gap: theme.spacing(2), // 16px
    borderRadius: theme.spacing(1), // 8px (rounded using theme spacing)
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)', // Keeping as dynamic value
    minWidth: theme.spacing(29.125) // 233px converted
  },
  priceTextSx: {
    ...theme.typography.custom({
      fontWeight: 500,
      lineHeight: theme.spacing(3)
    }), // 24px
    fontSize: theme.spacing(2), // 16px
    color: 'var(--color-text-tertiary)',
    marginBottom: theme.spacing(2), // 16px
    width: 'max-content'
  },
  creditTextSx: {
    ...theme.typography.custom({
      fontWeight: 500,
      lineHeight: theme.spacing(3)
    }), // 24px
    fontSize: theme.spacing(2), // 16px
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2), // 16px
    width: 'max-content'
  },
  subGridSx: {
    paddingLeft: { xs: theme.spacing(2), md: '0px !important' } // Dynamic per breakpoint
  },
  cardContentSx: {
    padding: '0px !important' // Keeping as is
  },
  spanStyle: {
    fontSize: theme.spacing(4), // 32px converted dynamically
    fontWeight: 700
  },
  btnSx: {
    padding: theme.spacing(1.25, 2.25), // 10px 18px
    gap: theme.spacing(1), // 8px
    borderRadius: theme.spacing(0.75) // 6px converted
  },
  footerTextSx: {
    ...theme.typography.custom({ lineHeight: theme.spacing(2.5) }), // 20px
    fontSize: theme.spacing(1.75), // 14px
    color: 'var(--color-text-secondary)',
    maxWidth: theme.spacing(59) // 29rem = 464px converted
  },
  footerBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  closeIcon: {
    color: 'var(--color-text-sidebar-icon)'
  },
  bestValueChip: {
    position: 'absolute',
    top: theme.spacing(-2), // -1rem = -16px
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'var(--color-success-bg)',
    color: theme.palette.primary.main,
    padding: theme.spacing(0.5, 1), // 4px 8px
    borderRadius: theme.spacing(1.5), // 12px
    boxShadow: theme.shadows[1],
    zIndex: 20
  },
  chipTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center'
  },
  loaderSx: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  loaderBox: {
    minHeight: '180px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  dividerSx: {
    marginTop: '8px'
  },
  paddingSx: {
    paddingLeft: '24px',
    paddingRight: '24px'
  },
  alertBoxSx: {
    paddingBottom: '16px'
  },
  footerTypoSx: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-purple)'
  },
  mainFooterSx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  subFooterBoxSx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  containerBox: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  footerPaddingSx: {
    paddingLeft: '24px',
    paddingRight: '40px'
  }
});

export const previousSearchSxs = {
  urlSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-primary)'
  },
  numbersSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-near-black)'
  },
  dateSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  }
};
